module.exports = (url) ->
  if url? && /// ^/ ([a-z0-9]|$) ///i.test(url)
    url
  else
    "/"



// WEBPACK FOOTER //
// ./app/scripts/lib/util/url/safe-return-url.coffee